export default __webpack_public_path__ + "static/media/qrcode-site-768w.d832b2d0.png";